import * as React from 'react';

export default function (props) {
  return (
    <div className="frow frow--justify-center frow--items-center">
      <p className="subtitle-one text-grey">No results</p>
    </div>
  );
}
